import {INPUT_VALUE_ARE_LOADING, INPUT_VALUE_FETCH_DATA_SUCCESS, INPUT_VALUE_HAVE_ERROR} from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function inputSearchReducer(state = initialState, action) {
    switch (action.type) {
        case INPUT_VALUE_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case INPUT_VALUE_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case INPUT_VALUE_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.inputSearch,
                loading:false,
            }

        default:
            return state;
    }
}
